import React from "react";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import { Controller, useFormContext } from "react-hook-form";
import { SectionDefinition } from "api/factories/form.factory";
import { getLocaleDateTimeFormat } from "utils";

export const DateTimePicker = ({ name, translation, value: defaultDate }: SectionDefinition) => {
    const { control, setValue } = useFormContext();

    return (
        <Controller
            defaultValue={defaultDate ? new Date(defaultDate) : null}
            name={name}
            control={control}
            render={({ value }) => {
                return (
                    <KeyboardDateTimePicker
                        inputVariant="outlined"
                        fullWidth
                        autoOk
                        disableToolbar={false}
                        variant="inline"
                        format={getLocaleDateTimeFormat()}
                        margin="none"
                        label={translation}
                        value={value}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={(date) => setValue(name, date, { shouldDirty: true })}
                    />
                );
            }}
        />
    );
};
